<button type="button" class="btn primary" [disabled]="disabled()" (click)="stepper().next(); click.emit($event)">
  {{ 'COMMON.NEXT' | translate }}
</button>
